// * Error taxonomy for EntityServiceResponseError.code (HTTP status preserved by
//   blackfiskAxiosRequest; null/undefined = network failure or unknown origin).
//   Pure classification only — no side effects, no store access.

// * A definitive auth failure: the server rejected the credentials/session itself.
//   These are the only statuses that justify collapsing the local session.
export const isAuthFailure = (code: string | number | null | undefined): boolean =>
  code === 401 || code === 403;

// * A transient failure: rate-limited, server-side 5xx, or network (no status at all —
//   undefined/null code means the request never got a usable HTTP response). Transient
//   failures must never collapse a session; retry or leave state untouched instead.
export const isTransient = (code: string | number | null | undefined): boolean =>
  code === undefined ||
  code === null ||
  code === 429 ||
  code === 500 ||
  code === 502 ||
  code === 503 ||
  code === 504;
